export default "__VITE_ASSET__Dnhqhwpm__"